import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { GraphqlResolverInput } from 'global';
import { Listing } from 'components/shared/TableListing';
import { useFormContext, useWatch } from 'react-hook-form';
import { CalendarEventsListingInput } from '@trnsact/trnsact-shared-types';

import { BulkActions } from './BulkActions';
import { CalendarMapper } from '../../mapper';
import { ListingFiltersValues } from './types';
import { eventsListingColumns } from './eventsListingColumns';
import { calendarApi, CalendarEventsListingResponse } from '../../api';

interface Props {
  userProfileId?: string | null;
}

export const EventsListing = ({ userProfileId }: Props) => {
  const [pagination, setPagination] = useState({ page: 1, perPage: 25 });

  const { control } = useFormContext<ListingFiltersValues>();
  const { search, ...filters } = useWatch({ control, name: 'filters' });

  const { loading, data, previousData } = useQuery<
    CalendarEventsListingResponse,
    GraphqlResolverInput<CalendarEventsListingInput>
  >(calendarApi.events.queries.listing, {
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        pagination,
        search,
        ...(userProfileId && { userProfileId }),
        filters: {
          ...(filters.type.length ? { type: filters.type } : {}),
          ...(filters.status.length ? { status: filters.status } : {}),
          ...(filters.priority.length ? { priority: filters.priority } : {}),
          ...(filters.dateRange?.from || filters.dateRange?.to ? { dateRange: filters.dateRange } : {}),
        },
      },
    },
  });

  const items = data?.dealActivity?.result?.items ?? previousData?.dealActivity?.result?.items ?? [];
  const tableData = items.map(CalendarMapper.toEventListingRow);

  return (
    <Listing
      selection={{}}
      loading={loading}
      tableData={tableData}
      columns={eventsListingColumns}
      pagination={{
        ...pagination,
        total: data?.dealActivity?.result?.pagination?.total ?? 0,
        onChange: nextValue => setPagination(prev => ({ ...prev, page: nextValue })),
      }}
      bulkActions={({ selected, onClose }) => <BulkActions selectedIds={selected} onClose={onClose} />}
    />
  );
};
